import React from 'react';
import { ThemeProvider } from 'styled-components';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter } from 'react-router-dom';

import FirebaseAuthProvider from 'containers/FirebaseAuthContext';
import WarningContextProvider from 'containers/WarningContext';
import StripeProvider from 'containers/StripeProvider';
import ApplicationConfigProvider from 'containers/ApplicationConfigContext';
import ApplicationStateProvider from 'containers/ApplicationStateContext';
import ErrorBoundary from 'components/ErrorBoundary';
import SmallScreenFallback from 'components/SmallScreenFallback/lazy';
import GlobalStyle from 'theme/globalStyle';
import theme from 'theme';
import { AntdThemeProvider } from 'theme/antd';
import Helmet from 'components/Helmet';
import client from 'lib/api/apollo';

import { Router } from '../Router';
import { FeatureFlagProvider } from '../../lib/featureFlags';

export function App() {
  return (
    <BrowserRouter>
      <Helmet />
      <ThemeProvider theme={theme}>
        <AntdThemeProvider>
          <ErrorBoundary>
            <GlobalStyle />
            <SmallScreenFallback>
              <StripeProvider>
                <ApolloProvider client={client}>
                  <ApplicationConfigProvider>
                    <FirebaseAuthProvider>
                      <FeatureFlagProvider>
                        <ApplicationStateProvider>
                          <WarningContextProvider>
                            <Router />
                          </WarningContextProvider>
                        </ApplicationStateProvider>
                      </FeatureFlagProvider>
                    </FirebaseAuthProvider>
                  </ApplicationConfigProvider>
                </ApolloProvider>
              </StripeProvider>
            </SmallScreenFallback>
          </ErrorBoundary>
        </AntdThemeProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
